import { useState } from 'react';
import { Button, Modal } from '@/components/UI';

interface LongTextPreviewProps {
    title: string;
    text: string;
}

const LongTextPreview = ({ title, text }: LongTextPreviewProps) => {
    const [open, setOpen] = useState(false);
    const shouldTruncate = text.length > 700;
    const preview = shouldTruncate ? `${text.slice(0, 700).trim()}...` : text;

    return (
        <>
            <div className="text-xs leading-5 text-zinc-500">{preview}</div>
            {shouldTruncate && (
                <Button className="mt-2" size="sm" variant="secondary" onClick={() => setOpen(true)}>
                    View Details
                </Button>
            )}
            <Modal draggable={false} isOpen={open} size="xl" title={title} onClose={() => setOpen(false)}>
                <div className="max-h-[70vh] overflow-auto whitespace-pre-wrap rounded border border-zinc-800 bg-zinc-950 p-3 text-sm leading-6 text-zinc-200">
                    {text}
                </div>
            </Modal>
        </>
    );
};

export default LongTextPreview;
